<form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm(validateForm.value)">
  <div nz-row nzGutter="24" class="header-search">
    <div nz-col nzSpan="10">
      <nz-form-item>
        <nz-form-control>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn trường" formControlName="school" [nzCustomTemplate]="schoolTemplate">
            <nz-option nzLabel="Trường mầm non Yên Đức" nzValue="1"></nz-option>
            <nz-option nzLabel="Trường mầm non Đại Bái" nzValue="2"></nz-option>
            <nz-option nzLabel="Trường mầm non Đại Lai" nzValue="3"></nz-option>
            <nz-option nzLabel="Trường mầm non Đông Cứu" nzValue="4"></nz-option>
            <nz-option nzLabel="Trường mầm non Giang Sơn" nzValue="5"></nz-option>
            <nz-option nzLabel="Trường mầm non Hoàng Đăng Miên" nzValue="6"></nz-option>
          </nz-select>
          <ng-template #schoolTemplate let-selected><div class="ant-select-selection-item-content flex items-center"><i nz-icon nzType="home" nzTheme="outline" class="mr-2"></i> {{ selected.nzLabel }} </div></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm nzSpan="7">
      <nz-form-item>
        <nz-form-control>
          <nz-select formControlName="scholastic" [nzCustomTemplate]="scholasticTemplate">
            <nz-option nzValue="21-22" nzLabel="Niên học 2021-2022"></nz-option>
            <nz-option nzValue="20-21" nzLabel="Niên học 2020-2021"></nz-option>
            <nz-option nzValue="19-20" nzLabel="Niên học 2019-2020"></nz-option>
            <nz-option nzValue="18-19" nzLabel="Niên học 2018-2019"></nz-option>
          </nz-select>
          <ng-template #scholasticTemplate let-selected>
            <div class="ant-select-selection-item-content flex items-center">
              <i nz-icon nzType="calendar" class="mr-2"></i> {{ selected.nzLabel }} 
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="5">
      <nz-form-item>
        <nz-form-control>
          <nz-select formControlName="semester" [nzCustomTemplate]="semesterTemplate">
            <nz-option nzValue="1" nzLabel="Học kỳ I"></nz-option>
            <nz-option nzValue="2" nzLabel="Học kỳ II"></nz-option>
            <nz-option nzValue="3" nzLabel="Cả năm"></nz-option>
          </nz-select>
          <ng-template #semesterTemplate let-selected><div class="ant-select-selection-item-content flex items-center"> <i nz-icon nzType="calendar" class="mr-2"></i> {{ selected.nzLabel }} </div></ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
